import { type ElementsPanelParams, openElementsPanel } from '../../blocks/common/elements-panel';
import { type EditorAppContext } from '../../types/editor-app-context.type';
import { FOOTER_COMPS_DATA, CATEGORY_IDS } from './constants';
import { PanelPlacementEnum, getCountersElements } from './getCountersElements';

export const openFooterElementsPanel = async (
  context: EditorAppContext,
  widgetRef: ElementsPanelParams['widgetRef'],
) => {
  const countersElements = await getCountersElements({
    sdk: context.sdk,
    flowAPI: context.flowAPI,
    token: context.appToken,
    placement: PanelPlacementEnum.FOOTER,
  });

  const { t } = context.flowAPI.translations;

  return openElementsPanel(context, {
    widgetRef,
    elementsData: [
      {
        label: t('post.elements.categories'),
        identifier: { role: FOOTER_COMPS_DATA.categories.role },
        categoryId: CATEGORY_IDS.mainElements,
        index: 0,
      },
      {
        label: t('post.elements.tags'),
        identifier: { role: FOOTER_COMPS_DATA.tags.role },
        categoryId: CATEGORY_IDS.mainElements,
        index: 1,
      },
      {
        label: t('post.elements.writer'),
        identifier: { role: FOOTER_COMPS_DATA.writer.role },
        categoryId: CATEGORY_IDS.mainElements,
        index: 2,
      },
      {
        label: t('post.elements.counters'),
        identifier: { role: FOOTER_COMPS_DATA.counters.role },
        categoryId: CATEGORY_IDS.mainElements,
        index: 3,
      },
      // Metadata section
      {
        label: t('post.elements.writer'),
        identifier: { role: FOOTER_COMPS_DATA.metadataWriter.role },
        categoryId: CATEGORY_IDS.metadata,
        index: 0,
      },
      {
        label: t('post.elements.publish-date'),
        identifier: { role: FOOTER_COMPS_DATA.publishDate.role },
        categoryId: CATEGORY_IDS.metadata,
        index: 1,
      },
      {
        label: t('post.elements.reading-time'),
        identifier: { role: FOOTER_COMPS_DATA.readingTime.role },
        categoryId: CATEGORY_IDS.metadata,
        index: 2,
      },
      // {
      //   label: t('post.elements.last-updated'),
      //   identifier: { role: FOOTER_COMPS_DATA.lastUpdated.role },
      //   categoryId: CATEGORY_IDS.metadata,
      //   index: 3,
      // },
      // Counters section
      ...countersElements,
      // Decorative section
      {
        label: t('post.elements.divider'),
        identifier: { role: FOOTER_COMPS_DATA.divider.role },
        categoryId: CATEGORY_IDS.decorative,
        index: 0,
      },
    ],
    categoriesData: [
      {
        id: CATEGORY_IDS.mainElements,
        title: t('post.elements.main-elements'),
      },
      { id: CATEGORY_IDS.metadata, title: t('post.elements.metadata') },
      { id: CATEGORY_IDS.counters, title: t('post.elements.counters') },
      { id: CATEGORY_IDS.decorative, title: t('post.elements.decorative') },
    ],
  });
};
